import React, { useState, useEffect } from 'react'
// import Meta from 'antd/lib/card/Meta'
import { Card, Avatar, Button } from 'antd'
import ArticleComments from '../../components/Article/comments/'
import {
  getArticleData,
  likeArticle,
  unlikeArticle,
  BookMark,
  unBookMark,
  followUser,
  unfollowUser,
  clear
} from '../../reducers/articlePageReducer'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import Styles from './index.module.css'
import { CommentOutlined, ArrowLeftOutlined } from '@ant-design/icons'

import LikeIcon from '../articles/components/LikeIcon'
import BookMarkIcon from '../articles/components/BookMarkIcon'
import FollowIcon from '../articles/components/FollowIcon'

const { Meta } = Card

const ArticlePage = () => {
  var { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const Data = useSelector((state) => state.articlePage)
  const user = useSelector((state) => state.auth.user)
  var liked = Data?.islike
  var bookMark = Data?.isBooked
  var follow = Data?.isFollow
  var likeCount = Data?.length
  const [commentState, setCommentState] = useState(false)

  const likeThisArticle = () => {
    if (!liked) {
      dispatch(likeArticle(id))
    } else {
      dispatch(unlikeArticle(id))
    }
  }
  const BookMarkThisArticle = () => {
    if (!bookMark) {
      dispatch(BookMark(id))
    } else {
      dispatch(unBookMark(id))
    }
  }
  const followAuthor = () => {
    if (!follow) {
      dispatch(followUser(id))
    } else {
      dispatch(unfollowUser(id))
    }
  }

  useEffect(() => {
    dispatch(getArticleData(id))
    return () => {
      dispatch(clear())
    }
  }, [dispatch, id])

  const hidden = user._id === Data?.myarticle?.authorPersonId._id ? true : false
  const hasComments = Data?.comments?.length > 0
  const shouldShow = hasComments || commentState

  return (
    <div className={Styles['article-card-container']}>
      <Button
        type="link"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: '16px', fontWeight: 600 }}
      >
        Back
      </Button>
      <Card
        hoverable
        className="article-card"
        actions={[
          <LikeIcon
            likesCount={likeCount}
            liked={liked}
            setLiked={likeThisArticle}
          />,
          <BookMarkIcon
            bookMarked={bookMark}
            setBookMark={BookMarkThisArticle}
            hidden={hidden}
          />,
          <FollowIcon
            followed={follow}
            setFollow={followAuthor}
            hidden={hidden}
          />,
          <Comment
            commentState={commentState}
            setCommentState={setCommentState}
          />
        ]}
        bordered={false}
      >
        <Meta
          style={{ alignItems: 'center' }}
          avatar={<Avatar src={Data?.myarticle?.authorPersonId?.photo} />}
          title={
            <div style={{ fontWeight: 600, fontSize: '16px' }}>
              {Data?.myarticle?.authorPersonId?.name}
            </div>
          }
        />
        <div
          style={{ fontSize: '16px', marginTop: '10px', marginLeft: '10px' }}
        >
          <b>{Data?.myarticle?.title}</b>
        </div>
        <Card bordered={false}>{Data?.myarticle?.text}</Card>

        {Data?.myarticle?.url && (
          <div style={{ marginTop: '16px', padding: '10px' }}>
            Reference article website : {''}
            <a
              href={Data.myarticle.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1677ff', fontWeight: 500 }}
              onClick={(e) => e.stopPropagation()} // prevent triggering card click
            >
              {Data.myarticle.url}
            </a>
          </div>
        )}
      </Card>
      <hr className={Styles['Hline']} />

      <>
        {shouldShow && (
          <Card bordered={false}>
            <ArticleComments showEditor={commentState} articleId={id} />
          </Card>
        )}
      </>
    </div>
  )
}

const Comment = ({ commentState, setCommentState }) => {
  return (
    <div
      className={Styles['like-container']}
      onClick={() => setCommentState(!commentState)}
    >
      {commentState ? (
        <CommentOutlined style={{ color: '#1890ff' }} />
      ) : (
        <CommentOutlined style={{ color: '#abb2b9 ' }} />
      )}
    </div>
  )
}

export default ArticlePage
